class LastReading {
  constructor(
    formattedValue,
    formattedTimeStamp,
  ) {
    this.formattedValue = formattedValue;
    this.formattedTimeStamp = formattedTimeStamp;
  }
}
export default LastReading;
